import React, { Component } from 'react';
import { Text, View, Pressable, StyleSheet, Image } from 'react-native';

import Navigation from '../../navigation';
import OPComponent from '../components/op_component';
import I18n from '../../I18n';

import { COLOR, FONT, FONT_SIZE } from '../../constants/styles';

export default class NoCasesView extends OPComponent {
  constructor(props) {
    super(props);
  }

  newCase() {
    Navigation.showModal({
      screen: 'CaseForm',
      title: I18n.ac('case.newCase'),
    });
  }

  render() {
    return (
      <View style={styles.container}>
        <View style={styles.circle}>
          <Image
            style={styles.torch}
            source={require('../../../resources/icon-torch.png')}
            resizeMode="contain"
          />
        </View>
        <Text style={styles.header}>{I18n.t('case.noCasesTitleText')}</Text>
        <Text style={styles.text}>{I18n.t('case.noCasesText')}</Text>
        <Pressable style={styles.button} onPress={this.newCase.bind(this)}>
          <Text style={styles.buttontext}>{I18n.t('case.addACase')}</Text>
        </Pressable>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLOR.contrast,
  },
  button: {
    height: 55,
    width: 325,
    borderRadius: 5,
    backgroundColor: COLOR.emphasis,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttontext: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.large,
    color: COLOR.textReversed,
    textAlign: 'center',
  },
  header: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.large,
    textAlign: 'center',
  },
  text: {
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    textAlign: 'center',
    padding: 30,
  },
  circle: {
    width: 90,
    height: 90,
    borderRadius: 90,
    backgroundColor: COLOR.contrast,
    shadowOpacity: 0.1,
    shadowRadius: 20,
    shadowColor: COLOR.shadow,
    shadowOffset: { height: 5, width: 0 },
    margin: 30,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 2,
  },
  torch: {
    width: 48,
    height: 48,
    tintColor: COLOR.emphasis,
  },
});
